import script from "./FeatureFlags.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeatureFlags.vue?vue&type=script&setup=true&lang=ts"

import "./FeatureFlags.vue?vue&type=style&index=0&id=6b0f3fdc&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b0f3fdc"]])

export default __exports__